import productAndServices from "../../../assets/data/header/productservices.json";
import ProductServiceCard from "../../../widgets/product-service-card/ProductServiceCard";
import "./ProductsAndServices.css";
import "./ProductsAndServicesResponsive.css";

function ProductsAndServices() {
  return (
    <div className="row m-0 position-relative product-services-bg">
      <div className="product-services-wrapper">
        <div className="product-service-header-wrapper">
          <h1>What We Offer</h1>
          <p>
            We offer more than just vegetables—our products and services are
            built around freshness, convenience, and wellness. Discover how we
            help you save time, eat better, and live healthier every day.
          </p>
        </div>
        <div className="row m-0 product-and-services-card">
          {productAndServices?.map((item, index) => {
            return <ProductServiceCard item={item} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default ProductsAndServices;
